import request from '../../../../lib/request';

const options = [
  {
    title: '9-week 1-on-1 Coaching',
    description: 'Get personalized coaching from David.',
    price: '$42/week',
    benefits: [
      '9 weeks of 1-on-1 coaching',
      'Weekly 30-45 minute video calls',
      'Weekly progress tracking',
      'Weekly nutrition guidance',
      'Weekly workout guidance',
      'Weekly goal setting',
      'Weekly feedback',
      'Weekly support',
      'Weekly accountability',
    ],
    link: 'https://dev-davidpark.dx2.link/coaching',
  },
  {
    title: 'One week Consultation',
    description: 'Get personalized consultation for a week.',
    price: '$99',
    benefits: [
      '1 week of 1-on-1 coaching',
      'Weekly 30-45 minute video calls',
      'Weekly progress tracking',
      'Weekly nutrition guidance',
      'Weekly workout guidance',
      'Weekly goal setting',
      'Weekly feedback',
      'Weekly support',
      'Weekly accountability',
    ],
    link: 'https://dev-davidpark.dx2.link/coaching',
  },
];

const Application = () => {
  return (
    <div className='bg-primary text-white p-4'>
      <div className='max-w-md mx-auto'>
        <div className='mb-4'>
          <h1 className='text-2xl font-bold mb-2'>Application for Coaching</h1>
          <p className='text-gray-300 text-sm'>
            Apply for coaching with David.
          </p>
        </div>

        <div className='space-y-4'>
          {options.map((option, i) => (
            <button
              key={i}
              className='bg-secondary rounded-xl p-6 w-full text-left'
              onClick={() => window.open(option.link, '_blank')}
            >
              <h3 className='text-lg font-bold mb-2'>{option.title}</h3>
              <p className='text-gray-300 text-sm mb-6'>{option.description}</p>
              <p className='text-gray-300 text-sm'>{option.price}</p>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Application;
